<template>
  <div class="container">
    <button
      v-if="extraSectionIndex && removeSection"
      type="button"
      class="close"
      aria-label="Close"
      @click="() => removeSection(extraSectionIndex)"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <Header
      :title="
        extraSectionIndex > 0
          ? 'Additional Section 3: Information About Your Experience'
          : 'Section 3: Information About Your Experience'
      "
    />
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label>
          <strong>What type of sexual violence did you experience?</strong>
          <br />
          <em
            >If you are a survivor of multiple assaults or instances of abuse,
            we ask that you please list these experiences separately via
            multiple forms. You can add another form at the end of Section
            3.</em
          >
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="experienceTypeRadio"
              :checked="values.experienceTypeRadio1"
              @change="
                e =>
                  handleValueChanged('experienceTypeRadio1', e.target.checked, {
                    radio: 5
                  })
              "
            />
            Rape/Sexual Assault
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="experienceTypeRadio"
              :checked="values.experienceTypeRadio2"
              @change="
                e =>
                  handleValueChanged('experienceTypeRadio2', e.target.checked, {
                    radio: 5
                  })
              "
            />
            Child Sexual Abuse
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="experienceTypeRadio"
              :checked="values.experienceTypeRadio3"
              @change="
                e =>
                  handleValueChanged('experienceTypeRadio3', e.target.checked, {
                    radio: 5
                  })
              "
            />
            Intimate Partner Violence
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="experienceTypeRadio"
              :checked="values.experienceTypeRadio4"
              @change="
                e =>
                  handleValueChanged('experienceTypeRadio4', e.target.checked, {
                    radio: 5
                  })
              "
            />
            Multiple Perpetrator Sexual Assault
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="experienceTypeRadio"
              :checked="values.experienceTypeRadio5"
              @change="
                e =>
                  handleValueChanged('experienceTypeRadio5', e.target.checked, {
                    radio: 5
                  })
              "
            />
            Other
          </label>
        </div>
        <input
          type="text"
          class="form-control mt-1"
          placeholder="Other"
          :value="values.experienceTypeOther"
          @keyup="
            e => handleValueChanged('experienceTypeOther', e.target.value)
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >How old were you when the assault or abuse began/occurred?</strong
          >
        </label>
        <input
          type="text"
          class="form-control"
          :value="values.experienceAge"
          @keyup="e => handleValueChanged('experienceAge', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong>Where did the assault or abuse occur?</strong>
          <br />
          <em>For example, home, school, public place, etc.</em>
        </label>
        <input
          type="text"
          class="form-control"
          :value="values.experiencePlace"
          @keyup="e => handleValueChanged('experiencePlace', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >In what city and state did the assault or abuse occur?</strong
          >
        </label>
        <input
          type="text"
          class="form-control"
          :value="values.experienceLocation"
          @keyup="e => handleValueChanged('experienceLocation', e.target.value)"
        />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 col-lg-6">
        <label>
          <strong>Duration of the assault or abuse:</strong>
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="experienceDurationRadio"
              :checked="values.experienceDurationRadio1"
              @change="
                e =>
                  handleValueChanged(
                    'experienceDurationRadio1',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            Once
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="experienceDurationRadio"
              :checked="values.experienceDurationRadio2"
              @change="
                e =>
                  handleValueChanged(
                    'experienceDurationRadio2',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            Repeated
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="experienceDurationRadio"
              :checked="values.experienceDurationRadio3"
              @change="
                e =>
                  handleValueChanged(
                    'experienceDurationRadio3',
                    e.target.checked,
                    { radio: 3 }
                  )
              "
            />
            Currently Ongoing
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong>Perpetrator(s):</strong>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.perpetratorCheckboxFriend"
              @change="
                e =>
                  handleValueChanged(
                    'perpetratorCheckboxFriend',
                    e.target.checked
                  )
              "
            />
            Friend/Acquaintance
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.perpetratorCheckboxFamily"
              @change="
                e =>
                  handleValueChanged(
                    'perpetratorCheckboxFamily',
                    e.target.checked
                  )
              "
            />
            Family Member
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.perpetratorCheckboxPartner"
              @change="
                e =>
                  handleValueChanged(
                    'perpetratorCheckboxPartner',
                    e.target.checked
                  )
              "
            />
            Intimate Partner (such as a spouse or partner)
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.perpetratorCheckboxStranger"
              @change="
                e =>
                  handleValueChanged(
                    'perpetratorCheckboxStranger',
                    e.target.checked
                  )
              "
            />
            Stranger
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.perpetratorCheckboxHelpingProfessional"
              @change="
                e =>
                  handleValueChanged(
                    'perpetratorCheckboxHelpingProfessional',
                    e.target.checked
                  )
              "
            />
            Helping Professional (teacher, doctor, religious leader, etc.)
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.perpetratorCheckboxOther"
              @change="
                e =>
                  handleValueChanged(
                    'perpetratorCheckboxOther',
                    e.target.checked
                  )
              "
            />
            Other
          </label>
        </div>
        <input
          type="text"
          class="form-control mt-1"
          placeholder="Other"
          :value="values.experiencePerpetratorOther"
          @keyup="
            e =>
              handleValueChanged('experiencePerpetratorOther', e.target.value)
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong>Did the perpetrator(s) use any of the following:</strong>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.experiencePerpetratorCheckboxUsedIntimidation"
              @change="
                e =>
                  handleValueChanged(
                    'experiencePerpetratorCheckboxUsedIntimidation',
                    e.target.checked
                  )
              "
            />
            Intimidation
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.experiencePerpetratorCheckboxUsedCoercion"
              @change="
                e =>
                  handleValueChanged(
                    'experiencePerpetratorCheckboxUsedCoercion',
                    e.target.checked
                  )
              "
            />
            Coercion
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.experiencePerpetratorCheckboxUsedPhysicalForce"
              @change="
                e =>
                  handleValueChanged(
                    'experiencePerpetratorCheckboxUsedPhysicalForce',
                    e.target.checked
                  )
              "
            />
            Physical Force
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.experiencePerpetratorCheckboxUsedDrugsAlcohol"
              @change="
                e =>
                  handleValueChanged(
                    'experiencePerpetratorCheckboxUsedDrugsAlcohol',
                    e.target.checked
                  )
              "
            />
            Drugs/Alcohol
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.experiencePerpetratorCheckboxUsedWeapon"
              @change="
                e =>
                  handleValueChanged(
                    'experiencePerpetratorCheckboxUsedWeapon',
                    e.target.checked
                  )
              "
            />
            Weapon
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.experiencePerpetratorCheckboxUsedKidnapping"
              @change="
                e =>
                  handleValueChanged(
                    'experiencePerpetratorCheckboxUsedKidnapping',
                    e.target.checked
                  )
              "
            />
            Kidnapping
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.experiencePerpetratorCheckboxUsedThreats"
              @change="
                e =>
                  handleValueChanged(
                    'experiencePerpetratorCheckboxUsedThreats',
                    e.target.checked
                  )
              "
            />
            Threats
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.experiencePerpetratorCheckboxUsedEmotionalAbuse"
              @change="
                e =>
                  handleValueChanged(
                    'experiencePerpetratorCheckboxUsedEmotionalAbuse',
                    e.target.checked
                  )
              "
            />
            Emotional Abuse
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.experiencePerpetratorCheckboxUsedGrooming"
              @change="
                e =>
                  handleValueChanged(
                    'experiencePerpetratorCheckboxUsedGrooming',
                    e.target.checked
                  )
              "
            />
            Grooming
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.experiencePerpetratorCheckboxUsedOther"
              @change="
                e =>
                  handleValueChanged(
                    'experiencePerpetratorCheckboxUsedOther',
                    e.target.checked
                  )
              "
            />
            Other
          </label>
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="Other"
          :value="values.experiencePerpetratorUsedOther"
          @keyup="
            e =>
              handleValueChanged(
                'experiencePerpetratorUsedOther',
                e.target.value
              )
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong>Additional details about your experience.</strong>
          <br />
          <em
            >You may use this space to include any additional details about the
            experience you feel comfortable sharing.</em
          >
        </label>
        <textarea
          class="form-control"
          rows="10"
          :value="values.experienceAdditionalDetails"
          @keyup="
            e =>
              handleValueChanged('experienceAdditionalDetails', e.target.value)
          "
        />
      </div>
    </div>
    <div v-if="!!addAdditionalSection" class="row mt-2">
      <div class="col">
        <button
          class="btn btn-secondary btn-sm"
          type="button"
          @click="addAdditionalSection"
        >
          Add Additional Section 3 Form
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Application/SectionHeader";
import { SectionThree } from "../../typings/application";

export default {
  name: "sectionThree",
  components: {
    Header
  },
  props: {
    values: {
      type: SectionThree,
      required: true,
      default: () => {
        return new SectionThree();
      }
    },
    onValueChanged: {
      type: Function,
      required: true,
      default: () => {}
    },
    addAdditionalSection: {
      type: Function,
      required: false,
      default: null
    },
    removeSection: {
      type: Function,
      required: false,
      default: null
    },
    extraSectionIndex: {
      type: Number,
      required: false,
      default: -1
    }
  },
  methods: {
    handleValueChanged(name, value, details) {
      const sectionName =
        this.extraSectionIndex && this.extraSectionIndex > 0
          ? `section3_${this.extraSectionIndex}`
          : "section3";
      this.onValueChanged(sectionName, name, value);
      if (name === "experienceTypeOther") {
        this.handleValueChanged("experienceTypeRadio5", value.length > 0, {
          radio: 5
        });
      } else if (name === "experiencePerpetratorOther") {
        this.onValueChanged(
          sectionName,
          "perpetratorCheckboxOther",
          value.length > 0
        );
      } else if (name === "experiencePerpetratorUsedOther") {
        this.onValueChanged(
          sectionName,
          "experiencePerpetratorCheckboxUsedOther",
          value.length > 0
        );
      } else if (name === "experienceTypeOther") {
        this.onValueChanged(
          sectionName,
          "experienceTypeRadio5",
          value.length > 0
        );
      } else if (details && details.radio) {
        // Ensures that only one radio within a radio group is selected at a
        // time.
        const radio = name.split("Radio");
        const index = parseInt(radio[1]);
        if (index !== 5) {
          this.onValueChanged(sectionName, "experienceTypeOther", "");
        }
        for (let i = 1; i <= details.radio; i++) {
          if (index !== i) {
            this.onValueChanged(sectionName, `${radio[0]}Radio${i}`, false);
          }
        }
      }
    }
  }
};
</script>
